import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

// 🔹 Reusable Try It Button
function TryItButton({ code }) {
  const handleClick = () => {
    const encodedCode = encodeURIComponent(code);
    window.open(`/editor?code=${encodedCode}`, "_blank");
  };

  return (
    <button onClick={handleClick} className="try_it_button">
      ▶ Try It
    </button>
  );
}

export default function JS_String_Reference() {
  const stringMethods = [
    {
      method: "at()",
      description: "Returns an indexed character from a string.",
      example: `let str = "JavaScript";
console.log(str.at(4)); // S`,
      code: `let str = "JavaScript";
console.log(str.at(4));`,
    },
    {
      method: "charAt()",
      description: "Returns the character at a specified index (position).",
      example: `let str = "Hello";
console.log(str.charAt(1)); // e`,
      code: `let str = "Hello";
console.log(str.charAt(1));`,
    },
    {
      method: "charCodeAt()",
      description: "Returns the Unicode of the character at a specified index.",
      example: `let str = "A";
console.log(str.charCodeAt(0)); // 65`,
      code: `let str = "A";
console.log(str.charCodeAt(0));`,
    },
    {
      method: "codePointAt()",
      description:
        "Returns the Unicode value at an index (position) in a string.",
      example: `let str = "😀";
console.log(str.codePointAt(0)); // 128512`,
      code: `let str = "😀";
console.log(str.codePointAt(0));`,
    },
    {
      method: "concat()",
      description: "Returns two or more joined strings.",
      example: `let a = "Hello";
let b = "World";
console.log(a.concat(" ", b)); // Hello World`,
      code: `let a = "Hello";
let b = "World";
console.log(a.concat(" ", b));`,
    },
    {
      method: "constructor",
      description: "Returns the string's constructor function.",
      example: `let str = "JS";
console.log(str.constructor);`,
      code: `let str = "JS";
console.log(str.constructor);`,
    },
    {
      method: "endsWith()",
      description: "Returns if a string ends with a specified value.",
      example: `let text = "Hello World";
console.log(text.endsWith("World")); // true`,
      code: `let text = "Hello World";
console.log(text.endsWith("World"));`,
    },
    {
      method: "fromCharCode()",
      description: "Returns Unicode values as characters.",
      example: `console.log(String.fromCharCode(72, 69, 76, 76, 79)); // HELLO`,
      code: `console.log(String.fromCharCode(72, 69, 76, 76, 79));`,
    },
    {
      method: "includes()",
      description: "Returns if a string contains a specified value.",
      example: `let str = "JavaScript";
console.log(str.includes("Script")); // true`,
      code: `let str = "JavaScript";
console.log(str.includes("Script"));`,
    },
    {
      method: "indexOf()",
      description: "Returns the index of the first occurrence of a value.",
      example: `let text = "Hello World";
console.log(text.indexOf("World")); // 6`,
      code: `let text = "Hello World";
console.log(text.indexOf("World"));`,
    },
    {
      method: "isWellFormed()",
      description: "Returns true if a string is well formed.",
      example: `let str = "Hello";
console.log(str.isWellFormed()); // true`,
      code: `let str = "Hello";
console.log(str.isWellFormed());`,
    },
    {
      method: "lastIndexOf()",
      description: "Returns the index of the last occurrence of a value.",
      example: `let text = "Hello Hello";
console.log(text.lastIndexOf("Hello")); // 6`,
      code: `let text = "Hello Hello";
console.log(text.lastIndexOf("Hello"));`,
    },
    {
      method: "length",
      description: "Returns the length of a string.",
      example: `let str = "JavaScript";
console.log(str.length); // 10`,
      code: `let str = "JavaScript";
console.log(str.length);`,
    },
    {
      method: "localeCompare()",
      description: "Compares two strings in the current locale.",
      example: `console.log("apple".localeCompare("banana")); // -1`,
      code: `console.log("apple".localeCompare("banana"));`,
    },
    {
      method: "match()",
      description:
        "Searches a string for a value or regex and returns the matches.",
      example: `let str = "The rain in Spain";
console.log(str.match(/ain/g)); // ['ain', 'ain']`,
      code: `let str = "The rain in Spain";
console.log(str.match(/ain/g));`,
    },
    {
      method: "matchAll()",
      description: "Searches a string for a regex and returns all matches.",
      example: `let text = "test1 test2";
console.log([...text.matchAll(/test\\d/g)]);`,
      code: `let text = "test1 test2";
console.log([...text.matchAll(/test\\d/g)]);`,
    },
    {
      method: "padEnd()",
      description: "Pads a string at the end.",
      example: `let str = "5";
console.log(str.padEnd(3, "0")); // 500`,
      code: `let str = "5";
console.log(str.padEnd(3, "0"));`,
    },
    {
      method: "padStart()",
      description: "Pads a string from the start.",
      example: `let str = "5";
console.log(str.padStart(3, "0")); // 005`,
      code: `let str = "5";
console.log(str.padStart(3, "0"));`,
    },
    {
      method: "repeat()",
      description: "Returns a new string with a number of copies of a string.",
      example: `let str = "Hi ";
console.log(str.repeat(3)); // Hi Hi Hi `,
      code: `let str = "Hi ";
console.log(str.repeat(3));`,
    },
    {
      method: "replace()",
      description: "Replaces part of a string with another value.",
      example: `let str = "I love cats";
console.log(str.replace("cats", "dogs")); // I love dogs`,
      code: `let str = "I love cats";
console.log(str.replace("cats", "dogs"));`,
    },
    {
      method: "replaceAll()",
      description: "Replaces all matches of a value or regex.",
      example: `let str = "Cats are cute. Cats are playful.";
console.log(str.replaceAll("Cats", "Dogs"));`,
      code: `let str = "Cats are cute. Cats are playful.";
console.log(str.replaceAll("Cats", "Dogs"));`,
    },
    {
      method: "search()",
      description:
        "Searches a string for a regex and returns the index of the match.",
      example: `let str = "JavaScript";
console.log(str.search("Script")); // 4`,
      code: `let str = "JavaScript";
console.log(str.search("Script"));`,
    },
    {
      method: "slice()",
      description: "Extracts a section of a string and returns it.",
      example: `let str = "Hello World";
console.log(str.slice(0, 5)); // Hello`,
      code: `let str = "Hello World";
console.log(str.slice(0, 5));`,
    },
    {
      method: "split()",
      description: "Splits a string into an array of substrings.",
      example: `let text = "a,b,c";
console.log(text.split(",")); // ['a','b','c']`,
      code: `let text = "a,b,c";
console.log(text.split(","));`,
    },
    {
      method: "startsWith()",
      description: "Checks whether a string begins with specified characters.",
      example: `let text = "Hello World";
console.log(text.startsWith("Hello")); // true`,
      code: `let text = "Hello World";
console.log(text.startsWith("Hello"));`,
    },
    {
      method: "substr()",
      description: "Deprecated. Use substring() or slice() instead.",
      example: `let str = "Hello World";
console.log(str.substr(0, 5)); // Hello`,
      code: `let str = "Hello World";
console.log(str.substr(0, 5));`,
    },
    {
      method: "substring()",
      description: "Extracts characters between two specified indices.",
      example: `let str = "Hello World";
console.log(str.substring(0, 5)); // Hello`,
      code: `let str = "Hello World";
console.log(str.substring(0, 5));`,
    },
    {
      method: "toLowerCase()",
      description: "Returns a string converted to lowercase letters.",
      example: `let str = "HELLO";
console.log(str.toLowerCase()); // hello`,
      code: `let str = "HELLO";
console.log(str.toLowerCase());`,
    },
    {
      method: "toUpperCase()",
      description: "Returns a string converted to uppercase letters.",
      example: `let str = "hello";
console.log(str.toUpperCase()); // HELLO`,
      code: `let str = "hello";
console.log(str.toUpperCase());`,
    },
    {
      method: "trim()",
      description: "Removes whitespace from both ends of a string.",
      example: `let str = "   Hello World   ";
console.log(str.trim()); // "Hello World"`,
      code: `let str = "   Hello World   ";
console.log(str.trim());`,
    },
    {
      method: "trimStart()",
      description: "Removes whitespace from the start.",
      example: `let str = "   Hello";
console.log(str.trimStart());`,
      code: `let str = "   Hello";
console.log(str.trimStart());`,
    },
    {
      method: "trimEnd()",
      description: "Removes whitespace from the end.",
      example: `let str = "Hello   ";
console.log(str.trimEnd());`,
      code: `let str = "Hello   ";
console.log(str.trimEnd());`,
    },
    {
      method: "valueOf()",
      description: "Returns the primitive value of a string.",
      example: `let str = new String("Hello");
console.log(str.valueOf());`,
      code: `let str = new String("Hello");
console.log(str.valueOf());`,
    },
  ];

  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">📚 JavaScript String Reference</h1>
      <p className="tutorial-intro">
        JavaScript provides many built-in <b>String methods</b> to manipulate
        and work with text efficiently. Below is a complete reference table with
        examples.
      </p>

      <div style={{ overflowX: "auto", marginTop: "20px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "#f9fafb",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 0 15px rgba(0,0,0,0.2)",
          }}
        >
          <thead style={{ backgroundColor: "#0f172a", color: "white" }}>
            <tr>
              <th style={{ padding: "10px" }}>Method</th>
              <th style={{ padding: "10px" }}>Description</th>
              <th style={{ padding: "10px" }}>Example</th>
            </tr>
          </thead>
          <tbody>
            {stringMethods.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f1f5f9" : "#e2e8f0",
                  borderBottom: "1px solid #cbd5e1",
                }}
              >
                <td
                  style={{
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#0f172a",
                    width: "15%",
                  }}
                >
                  {item.method}
                </td>
                <td style={{ padding: "10px", color: "#334155", width: "35%" }}>
                  {item.description}
                </td>
                <td style={{ padding: "10px", width: "50%" }}>
                  <div className="code-demo-box">
                    <CodeCopyBlock code={item.example} />
                    <TryItButton code={item.code} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          marginTop: "2rem",
          background: "linear-gradient(135deg, #fef3c7, #fde68a)",
          padding: "1rem",
          paddingLeft: "35px",
          borderRadius: "12px",
        }}
      >
        <h2 style={{ color: "#92400e" }}>💡 Tips</h2>
        <ul className="tutorial-list-points">
          <li>
            Strings in JavaScript are immutable (you can’t change them
            directly).
          </li>
          <li>
            Use <code>+ </code> or template literals (<code>` `</code>) for
            concatenation.
          </li>
          <li>Always check case sensitivity when comparing strings.</li>
        </ul>
      </div>
    </div>
  );
}
